<template>
<div>
    <div v-show="!showLockPopup">
      <div class="overlay">
        <div class="top-text">
          <div class="wip-text">Work In Progress!</div>
        </div>
        <div class="fbp">
          <tl-header type="h3" class="title">
                  FBP
          </tl-header>
          <div v-if="runFbp">
              <div class="existing-fbp">
                  <span> Last Run: <b> {{lastRunDate}} </b> </span>
                  <span> Total: <b> {{total}} </b> </span>
              </div>
              <div class="fbppayout">
                  <span> Last Payout: <b> {{lastPayout}} </b> </span>
              </div>
              <div class="pending">
                  <span> Pending:   </span> <b> {{pendingAmt}} </b>
              </div>
              <v-progress-linear
                  class="orangeLine"
                  background-color="#fdefef"
                  color="#ea8f54"
                  height="3"
                  :value="valueOrange"
                  ></v-progress-linear>
              <button class="pendingBtn" @click="approve"> <b>Approve Now </b></button>

              <div class="approved">
                  <span> Approved:   </span> <b> {{approvedAmt}} </b>
              </div>
              <v-progress-linear
                  class="greenLine"
                  background-color="#edfff5"
                  color="#1db25f"
                  height="5"
                  :value="valueGreen"
                  ></v-progress-linear>
              <button class="editBtn" @click="edit"> <b>Edit </b></button>
          </div>

          <div>
              <div class="monthly-fbp">
                  <img class="disabledMode" src="@/assets/prev-icon.png" /><span> January • 2018-2019 </span> <img class="disabledMode" src="@/assets/next-icon.png" />
              </div>
              <div class="align-center">
                  <span> Last Run : {{lastRun}} </span>
              </div>
              <div class="bottom" />
              <div class="monthFbpDetails">
                  <span> Total Claim: <b> {{totalClaim}} </b> </span>
                  <div class="verLine" />
                  <span> Last Payout: <b> {{monthlyLastPayout}} </b> </span>
                  <div class="verLine" />
                  <span> Carry Forward: <b> {{carryFwd}} </b> </span>
              </div>
              <div class="bottom" />
              <div class="pending">
                  <span> Pending:   </span> <b> {{monthPendingAmt}} </b>
              </div>
              <v-progress-linear
                  class="orangeLine"
                  background-color="#fdefef"
                  color="#ea8f54"
                  height="3"
                  :value="valueOrange"
                  ></v-progress-linear>
              <button disabled  class="pendingBtn disabledMode" @click="approve"> <b>Approve Now </b></button>
              <div class="approved">
                  <span> Approved:   </span> <b> {{monthApprovedAmt}} </b>
              </div>
              <v-progress-linear
                  class="greenLine"
                  background-color="#edfff5"
                  color="#1db25f"
                  height="5"
                  :value="valueGreen"
                  ></v-progress-linear>
              <div class="rejected">
                  <span> Rejected:   </span> <b> {{monthRejectedAmt}} </b>
              </div>
              <v-progress-linear
                  class="redLine"
                  background-color="#ffe6e7"
                  color="#ea5455"
                  height="5"
                  :value="valueRed"
                  ></v-progress-linear>

          </div>



          <div v-show="!showLockPopup" />
          <div class="runBtn" v-show="runFbp">
            <btn disabled text="RUN FBP" type="primary" @click="runfbp" />
          </div>
          <div class="btns">
            <btn class="disabledMode" disabled text="LOCK FBP" type="secondary" @click="lockfbp" />
            <btn class="disabledMode" disabled text="RUN FBP" type="primary" @click="runfbp" />
          </div>

          <div v-show="showLockPopup">
              <div class="lockedFbpDetails">
                  <span> FBP Locked For “ <b> {{selectedMonth}} </b>” Month </span>
                  <img src="" class="lockedImg" />
                  <btn-grp class="btnGrp">
                    <btn class="disabledMode" disabled text="UNLOCK FBP" type="secondary" @click="unlockfbp" />
                    <btn class="disabledMode" disabled text="DOWNLOAD REPORTS" type="primary" @click="downloadReports" />
                  </btn-grp>
              </div>

          </div>
          <pop-up-message
            popupHeaderMessage="Warning"
            v-if="showUnlockPopup"
            :popupType="'Warning'"
            @back="backFromPopup"
            class="popupClass"
          >
            <template v-slot:bottomContent>
                <span class="popupdetails"> Reason To Unlock FBP </span>
              <txt
                  type="textarea"
                  class="custom-width"
                  rows="5"
                 />
              <div class="popup-btn-group">
                <button class="btn-popup-secondary" type="button" @click="cancel()"> <b> Cancel </b></button>
                <button class="btn-popup" type="button" @click="submit"> <b> Submit </b></button>
              </div>
            </template>
          </pop-up-message>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
    name: "FBP",
    data() {
        return {
            runFbp: false,
            showLockPopup: false,
            showUnlockPopup: false,
            selectedMonth: 'January',
            lastRunDate: '06/08/19',
            total: '60,000',
            lastPayout: '50,000',
            valueOrange: '5',
            valueGreen:'',
            valueRed: '5',
            pendingAmt: '40,589',
            approvedAmt: '10,589',
            lastRun: '06/09/2019',
            totalClaim: '40,589',
            carryFwd: '40,589',
            monthlyLastPayout: '40,589',
            monthPendingAmt: '40,589',
            monthApprovedAmt: '4,589',
            monthRejectedAmt: '4,589',
        }
    },
    methods: {
        approve() {
            //console.log('isndie approve')
        },
        lockfbp() {
            this.showLockPopup = true
        },
        unlockfbp() {
            this.showUnlockPopup = true
        },
        runfbp() {
            //console.log('inside run fbp')
        },
        downloadReports() {
            //console.log('inside download reports')
        },
        cancel() {
            this.showUnlockPopup = false
        },
        submit() {
            this.showUnlockPopup = false
        },
    }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../scss/components/btn.scss";
.title{
  padding: 20px;
}
.existing-fbp {
    display: flex;
    padding: 0px 0px 8px 40px;
    justify-content: space-between;
    span {
        font-size: 14px;
        margin-right: 50px;
        color: #606060;
    }
}
.fbppayout {
    padding: 0px 0px 30px 40px;
    span {
        font-size: 14px;
        color: #606060;
    }
}
.pending {
    display: flex;
    padding: 0px 0px 0px 40px;
    margin-top: 20px;
    span {
        font-size: 11px;
        margin-top: 5px;
        margin-right: 10px;
        color: #606060;
    }
    b {
        font-size: 20px;
        color: #ea8f54;
    }
}
.orangeLine {
    width: calc(100% - 80px);
    height: 3.4px;
    border-radius: 2.5px;
    background-color: #fdefef;
    margin: 10px 40px 10px 40px;
}
.greenLine {
    width: calc(100% - 80px);
    height: 3.4px;
    border-radius: 2.5px;
    margin: 10px 40px 10px 40px;
    background-color: #edfff5;
}
.redLine {
  width: calc(100% - 80px);
  height: 3.4px;
  border-radius: 2.5px;
  margin: 10px 40px 10px 40px;
  background-color: #ffe6e7;
}
.pendingBtn {
  width: 118px;
  height: 35px;
  margin-left: 40px;
  margin-bottom: 10px;
  border-radius: 4px;
  background-color: #ea8f54;
  color: #ffffff;
}
.approved {
    display: flex;
    padding: 0px 0px 0px 40px;
    margin-top: 20px;
    span {
        font-size: 11px;
        margin-top: 5px;
        margin-right: 10px;
        color: #606060;
    }

    b {
        font-size: 20px;
        color: #1db25f;
    }
}
.rejected {
    display: flex;
    padding: 0px 0px 0px 40px;
    margin-top: 20px 0px 20px 0px;
    span {
        font-size: 11px;
        margin-top: 5px;
        margin-right: 10px;
        color: #606060;
    }

    b {
        font-size: 20px;
        color: #ea5455;
    }
}
.editBtn {
  width: 118px;
  height: 35px;
  margin-left: 40px;
  margin-bottom: 25px;
  border-radius: 4px;
  background-color: #1db25f;
  color: #ffffff;
}
.bottom {
  width: 100%;
  height: 1px;
  opacity: 0.3;
  border: solid 1px #cbcbcb;
}
.runBtn {
    margin-left: 125px;
    margin-top: 20px;
}
.runFbp {
  width: 256px;
  height: 45px;
  border-radius: 4px;
  background-color: #5d409f;
  color: #ffffff;
}
.lockFbp {
  width: 250px;
  height: 45px;
  border-radius: 4px;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
  border: solid 2px #37c6c0;
  background-color: #ffffff;
  color: #37c6c0;
  margin-right: 15px;
  margin-left: 15px;
}
.monthly-fbp {
    display: flex;
    justify-content: center;
    img {
        cursor: pointer;
    }
    span {
        font-size: 16px;
        font-weight: 600;
        color: #34c0be;
        margin-left: 25px;
        margin-right: 25px;
    }
}
.align-center {
    margin-bottom: 10px;
    span {
        font-size: 12px;
        text-align: center;
        color: #606060;
    }
}
.monthFbpDetails {
    display: flex;
    // margin: 15px 0px 15px 0px;
    span {
      flex: 1;
      flex-grow: 1;
      padding: 15px;
      margin: 20px 0px 20px 0px;
        font-size: 12px;
        text-align: center;
        color: #606060;
    }
}
.verLine {
  width: 1px;
  height: auto;
  border: solid 1px #efefef;
}
.btns {
    display: flex;
    justify-content: center;
}
.popupbtns {
    display: flex;
    margin-top: 175px;
}
.lockedFbpDetails {
    background: white;
    width: 485px;
    text-align: center;
    height: 390px;
    opacity: 0.9;
    margin-top: 60px;
    span {
        font-size: 20px;
        color: #6e6e6e;
        padding: 0px 94px 0px 94px;
    }
}
.lockedImg {
    margin-top: 60px;
    margin-bottom: 60px;
}
.custom-width {
    width: 430px;
    // height: 128px;
    margin-top: 20px;
    margin-bottom: 20px;
    border-radius: 4px;
    // border: solid 1px #dadada;
    background-color: #ffffff;
}

.btn-popup {
      display: block;
      border-radius: 4px;
      min-width: 150px;
      padding: 0px 10px;
      height: 35px;
      background-color: #5d409f;
      color:#ffffff;
}
    .btn-popup-secondary {
      display: block;
      border-radius: 4px;
      min-width: 150px;
      padding: 0px 10px;
      height: 35px;
      background-color: #ffffff;
      border: #34c0be solid 1px;
      color: #34c0be;
    }
.popupClass {
    height: 527px;
}
.popupdetails {
    font-size: 16px;
    text-align: center;
    color: #6e6e6e;
    margin-top: 20px;
}
.overlay {
  position: relative;
}

.top-text {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: 100%;
  z-index: 1;
}
.wip-text {
  font-family: Montserrat;
  font-size: 32px;
  font-weight: 600;
  text-align: center;
  color: #444444;
  margin-top: 30%;
  transform: rotate(-45deg);
}
.fbp {
  position: relative;
}
</style>
